import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from '../../../kms.service';

@Component({
  selector: 'app-model-add',
  templateUrl: './model-add.component.html',
  styleUrls: ['./model-add.component.css']
})
export class ModelAddComponent implements OnInit {
  @ViewChild('modal') modal: SwModalframeComponent;    //弹出层组件
  @Input() param:any;
  @Output() callback = new EventEmitter(); //抛出事件
  // 标题
  headerLoGo:string =  '';
  // 已有模型数据
  usableModelList = [];
  // 不可选中的节点
  readonlySelfIds:any = [];
  // 模型名称
  modelName = '';
  // 概念树数据
  conceptTreeData:any = [];
  // 选中的概念节点
  selectedNodes:any = [];
  // 数据绑定对象
  model: any = {}; 
  // 提交按钮是否禁用
  clickEnable = true; 
  // 当前登录用户所属组织
  orgId:string = '';
  // 当前登录用户绑定的角色
  userRole:string = '';
  constructor(
    private jwt: SwJwtService,
    private box: SwMassageBoxService,  //消息提示框
    private kmsService: KmsService,   //请求服务
  ) { }

  ngOnInit() {
    this.orgId = this.jwt.getToken('orgId');
    this.userRole = this.jwt.getToken('userRole');
    this.clickLoca();
  }
  
  clickLoca() {
    // 新增模型数据 默认绑定模型基础数据
    this.headerLoGo = "模型创建";
    this.model.approvalStatus = 0;
    // 查询所有可选的数据模型
    this.queryUsableModelList();
  }

  // 查询所有可选的数据模型
  queryUsableModelList(){
    let params = {
      'isPublic': 1,  // 是否查询公开的数据模型，主要用于知识库管理员创建数据模型时，选择模板进行调用
      'isAllowed': 1,  // 是否只查询审核通过的版本： 0 否 1 是
      'isDelete': 0,   // 是否删除： 0 是 1 否
      'orgId': this.orgId,
    }
    this.kmsService.queryUsableModelList(params).subscribe(
      data => {
        if(data.code == '200'){
          if(data.data && data.data.length>0){
            this.usableModelList = data.data;
            this.usableModelList.forEach(item => {
              if(item.pid == 'root'){
                this.readonlySelfIds.push(item.id);
              }
            })
          }
        }else{
          this.box.waring(data.msg);
        }
      }
    )
  }

  // 切换选中模型
  modelChange(event){
    this.getConceptTree(event.id);
    let node = this.usableModelList.filter(item => item.id == event.id);
    let parent = this.usableModelList.filter(item => item.id == node[0].pid);
    if(parent.length > 0){
      this.modelName = parent[0].text;
    }else{
      this.modelName = '';
    }
    this.selectedNodes = [];
  }

  // 清除选中模型
  modelClear(event){
    this.conceptTreeData = [];
    this.modelName = '';
    this.selectedNodes = [];
  }

  // 根据当前选中的数据模型对应版本的modelVerId获取概念树数据
  getConceptTree(modelVerId) {
    this.kmsService.getConceptTree(modelVerId).subscribe(
      result => {
          if (result.code == 200) {
            if (!result.data) {
              this.conceptTreeData = [];
              return;
            }
            let datas = result.data;
            this.conceptTreeData = datas;
            this.conceptTreeData.forEach(item => {
              if(item.pid == 'root' && this.modelName){
                item.text = this.modelName +' '+ item.text
              }
            });
          }
      }
    )
  }

  // 选中或取消概念树节点
  handleVotedClick(event){
    this.selectedNodes = event;
  }

  // 保存新增的模型信息
  onSubmit({ value, valid }, event: Event) {
    if (valid) {
      this.clickEnable = false;
      let params:any = value;
      // 判断是否有选中的概念节点
      if(this.selectedNodes.length == 0){
        delete params.copyId;
        delete params.copy;
        delete params.concepts;
      }else{
        delete params.copyId;
        // 获取根节点
        let rootNode = this.conceptTreeData.filter(item => item.pid === 'root')[0];
        // 获取当前选中节点
        let conceptNodes = JSON.parse(JSON.stringify(this.selectedNodes));
        let selectedData = []
        conceptNodes.forEach(item => {
          selectedData.push(item.data);
        })
        // 获取选中节点及其父节点
        let res = [];
        selectedData.forEach(item => {
            res = this.getParents(item,res);
        })
        // 处理数据
        params['copy'] = true;
        params['concepts'] = [];
        res.forEach(el => {
          if(el.pid != 'root'){
            let parentItem = this.conceptTreeData.filter(item1 => item1.id === el.pid)[0];
            let child = {
              conceptId: el.id,
              conceptCode: el.code,
              conceptName: el.text,
              parentId: el.pid == rootNode.id ? 'root' : el.pid,
              parentCode: el.pid == rootNode.id ? '' : parentItem.code,
              conceptLevel: el.level,
              mapping: el.mapping,
              modelVerId: el.modelVerId
            }
            params['concepts'].push(child);
          }
        })
      }
      params['orgId'] = this.orgId;
      this.kmsService.saveOrUpdateModel(params).subscribe(
        data => {
          this.clickEnable = true;
          if(data.code == '200'){
            this.box.success('保存成功！');
            this.modal.toggle();
            this.callback.emit(true);
          }else{
            this.box.waring(data.msg);
          }
        }
      )
    }
  }

  // 根据当前项获取所有父级
  getParents(item,parents){
    if(parents.filter(item1 => item1.id == item.id) == 0){
      parents.push(item);
    }
    let parentNode = this.conceptTreeData.filter(el => el.id == item.pid);
    if(parentNode.length == 0){
      return parents
    }else{
      return this.getParents(parentNode[0],parents);
    }
  }
}
